var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccounts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93749 5.16868C6.99498 5.16868 5.42027 6.74339 5.42027 8.6859C5.42027 10.6284 6.99498 12.2031 8.93749 12.2031C10.88 12.2031 12.4547 10.6284 12.4547 8.6859C12.4547 6.74339 10.88 5.16868 8.93749 5.16868ZM4.32971 8.6859C4.32971 6.1411 6.39268 4.07812 8.93749 4.07812C11.4823 4.07812 13.5453 6.1411 13.5453 8.6859C13.5453 11.2307 11.4823 13.2937 8.93749 13.2937C6.39268 13.2937 4.32971 11.2307 4.32971 8.6859Z",
    fill: "#17253F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 5.16868C18.3054 5.16868 17.337 6.13711 17.337 7.33174C17.337 8.52636 18.3054 9.49479 19.5 9.49479C20.6946 9.49479 21.6631 8.52636 21.6631 7.33174C21.6631 6.13711 20.6946 5.16868 19.5 5.16868ZM16.2464 7.33174C16.2464 5.53482 17.7031 4.07812 19.5 4.07812C21.2969 4.07812 22.7536 5.53482 22.7536 7.33174C22.7536 9.12866 21.2969 10.5853 19.5 10.5853C17.7031 10.5853 16.2464 9.12866 16.2464 7.33174Z",
    fill: "#17253F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00360107 23.3107C-0.00360107 18.3716 3.99834 14.3696 8.93751 14.3696C13.8767 14.3696 17.8786 18.3716 17.8786 23.3107V24.1269H-0.00360107V23.3107ZM1.09166 23.0363H16.7834C16.6389 18.8266 13.1825 15.4602 8.93751 15.4602C4.6925 15.4602 1.23617 18.8266 1.09166 23.0363Z",
    fill: "#17253F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 12.7519C17.0528 12.7519 14.9791 14.3815 14.3149 16.6142L13.2696 16.3032C14.0678 13.6203 16.5577 11.6614 19.5 11.6614C23.0918 11.6614 26.0037 14.5732 26.0037 18.165V19.2519H15.9589V18.1614H24.9131C24.9111 15.1736 22.4883 12.7519 19.5 12.7519Z",
    fill: "#17253F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_1049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.831299)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccounts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/accounts.b1c1d5c338bacc77d28c575e9b1ea7ff.svg";